export default "__VITE_PUBLIC_ASSET__5a7e1ae9__"